import { API_URL } from '../config/api';

/**
 * Simple API client wrapper that uses the configured API_URL
 */
// Check for license errors and redirect
function checkLicenseError(response: Response, data: any) {
  if (response.status === 402 && data.error?.code === 'LICENSE_EXPIRED') {
    window.location.href = '/license-expired';
    throw new Error('License expired');
  }
}

export const apiClient = {
  async get(path: string) {
    const response = await fetch(`${API_URL}${path}`, {
      credentials: 'include',
    });
    const data = await response.json();
    if (!response.ok) {
      checkLicenseError(response, data);
      throw new Error(data.error || `API request failed: ${response.status}`);
    }
    return data;
  },

  async post(path: string, body?: any) {
    const response = await fetch(`${API_URL}${path}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await response.json();
    if (!response.ok) {
      checkLicenseError(response, data);
      throw new Error(data.error || `API request failed: ${response.status}`);
    }
    return data;
  },

  async put(path: string, body?: any) {
    const response = await fetch(`${API_URL}${path}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }
    return response.json();
  },

  async delete(path: string) {
    const response = await fetch(`${API_URL}${path}`, {
      method: 'DELETE',
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }
    return response.json();
  },
};
